import { useNavigate } from 'react-router-dom';
import { Client } from 'src/services/clientService';
import { ContainerBox, FlexContainer, TypographyText } from 'src/tef/components';
import { sanitizeInput } from 'src/utils/security';

interface ClientListItemProps {
  client: Client;
  onClick?: (clientId: string) => void;
  className?: string;
}

export default function ClientListItem({ client, onClick, className = '' }: ClientListItemProps) {
  const navigate = useNavigate();
  const sanitizedName = sanitizeInput(client.name);

  const handleClick = () => {
    if (onClick) {
      onClick(client.id);
    } else {
      navigate(`/client/${client.id}`);
    }
  };

  return (
    <FlexContainer
      align="center"
      gap="sm"
      onClick={handleClick}
      className={`group py-2.5 px-3 rounded-md hover:bg-slate-100 dark:hover:bg-slate-700 active:bg-slate-200 dark:active:bg-slate-600 cursor-pointer transition-all duration-200 ease-in-out ${className}`}
      aria-label={`Client: ${sanitizedName}`}
      role="button"
      tabIndex={0}
      title={sanitizedName}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <ContainerBox
        className={`w-2 h-2 rounded-full flex-shrink-0 ${
          client.status === 'active'
            ? 'bg-green-500 dark:bg-green-400'
            : client.status === 'inactive'
              ? 'bg-slate-400 dark:bg-slate-500'
              : 'bg-yellow-500 dark:bg-yellow-400'
        }`}
      />
      <TypographyText
        variant={{ size: 'base' }}
        weight="medium"
        truncate
        className="group-hover:text-foreground transition-colors flex-1"
      >
        {sanitizedName}
      </TypographyText>
    </FlexContainer>
  );
}
